import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/callscreening/queues")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Queues",
      crumbTo: "/callscreening/queues",
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
